
import { motion } from 'framer-motion';

const Philosophy = () => {
  const principles = [
    {
      icon: 'ri-heart-line',
      title: 'Authentic Emotion',
      description: 'Every character, every scene is grounded in genuine human emotion, creating stories that resonate deeply with readers.',
    },
    {
      icon: 'ri-compass-line',
      title: 'Moral Complexity',
      description: 'Exploring the gray areas of human experience, where right and wrong are not always clear-cut.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Literary Craft',
      description: 'A commitment to the art of storytelling, honoring the traditions of literature while embracing innovation.',
    },
    {
      icon: 'ri-global-line',
      title: 'Universal Themes',
      description: 'Stories that transcend cultural boundaries, speaking to the shared experiences that unite humanity.',
    },
  ];

  return (
    <section className="py-24 px-8 lg:px-16 bg-light-cream">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="font-playfair text-5xl font-bold text-charcoal mb-6">
            Writing Philosophy
          </h2>
          <p className="font-lato text-lg text-warm-gray max-w-3xl mx-auto">
            The principles that guide every story, every character, and every word
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {principles.map((principle, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-burgundy/10 rounded-full mb-6">
                <i className={`${principle.icon} text-3xl text-burgundy`}></i>
              </div>
              <h3 className="font-playfair text-2xl font-bold text-charcoal mb-4">
                {principle.title}
              </h3>
              <p className="font-lato text-warm-gray leading-relaxed">
                {principle.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
